package ui.company

import androidx.compose.runtime.*
import androidx.compose.ui.text.input.TextFieldValue
import common.frontend.api.Io
import common.frontend.api.canCompanyAdd
import io.Repository
import kotlinx.coroutines.launch
import tk.mallumo.compose.navigation.navTo_CompanyUI
import tk.mallumo.compose.navigation.viewmodel.NavigationViewModel
import tk.mallumo.compose.navigation.viewmodel.VM
import tk.mallumo.utils.DataState
import tk.mallumo.utils.mutableDataState
import tools.findRoot
import tools.printStackTraceInDebug
import ui.company.detail.CompanyArgs
import ui.snackBarStateGlobal

@VM
class CompanyListingVM : NavigationViewModel() {

    private lateinit var scopeUi: CompanyListingScope


    val searchFiled = mutableStateOf(TextFieldValue(""))
    var state by mutableDataState<CompanyListingScope.Wrapper>()
        private set


    sealed interface Action {
        class New(val item: Io.ListingCompany.Item) : Action
        companion object {

            @Composable
            fun rememberAction(vm: CompanyListingVM): (Action) -> Unit {
                return remember {
                    { act ->
                        when (act) {
                            is New -> vm.newCompany(act.item)
                        }
                    }
                }
            }
        }
    }


    fun init(scopeUi: CompanyListingScope) {
        this.scopeUi = scopeUi
        if (state !is DataState.Result) {
            state = DataState.Loading()
        }
        scope.launch {
            runCatching {
                state = DataState.Result(
                    CompanyListingScope.Wrapper(
                        canAdd = scopeUi.login.canCompanyAdd(),
                        listing = Repository.api.company.listing()
                    )
                )
            }.onFailure {
                it.printStackTraceInDebug()
                state = DataState.Error(it.message!!, throwable = it)
            }
        }
    }


    private fun newCompany(item: Io.ListingCompany.Item) {
        scope.launch {
            runCatching {
                val new = Repository.api.company.add(item)
                state.entry?.add(0, new)
                scopeUi.nav.findRoot().navTo_CompanyUI(CompanyArgs(companyId = new.id))
                scopeUi.vmGlobal.reloadCompanyWithLocation(scopeUi.login)
            }.onFailure {
                it.printStackTraceInDebug()
                snackBarStateGlobal.showSnackbar(
                    it.message!!,
                    withDismissAction = true
                )
            }
        }
    }

    override fun onRelease() {
        state.entry?.release()
        state = DataState.Idle()
    }

}
